import api from './api';
import type { UserPrompt, UserPromptMethodology } from '@trading/shared';

export interface UserPromptCreateInput {
  name: string;
  content: string;
  methodology?: UserPromptMethodology | null;
  isDefault?: boolean;
}

export type UserPromptUpdateInput = Partial<UserPromptCreateInput>;

export const userPromptsService = {
  async list(): Promise<UserPrompt[]> {
    const response = await api.get<{ items: UserPrompt[] }>('/user-prompts');
    return response.data.items;
  },

  async create(input: UserPromptCreateInput): Promise<UserPrompt> {
    const response = await api.post<UserPrompt>('/user-prompts', input);
    return response.data;
  },

  async update(id: string, input: UserPromptUpdateInput): Promise<UserPrompt> {
    const response = await api.patch<UserPrompt>(`/user-prompts/${id}`, input);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/user-prompts/${id}`);
  },

  async setDefault(id: string): Promise<UserPrompt> {
    const response = await api.post<UserPrompt>(`/user-prompts/${id}/default`);
    return response.data;
  },
};
